type WithId = {
  id: number | string
  [key: string]: any
}

type WithIdString<T extends WithId> = Omit<T, 'id'> & { id: string }

export const convertIdToString = <T extends WithId>(obj: T): WithIdString<T> => ({
  ...obj,
  id: obj.id.toString(),
})
